import {CardPanel} from "../../../stemjs/src/ui/CardPanel.jsx";
import {UI} from "../../../stemjs/src/ui/UIBase.js";
import {Level} from "../../../stemjs/src/ui/Constants.js";
import {TextArea} from "../../../stemjs/src/ui/input/Input.jsx";
import {Button} from "../../../stemjs/src/ui/button/Button.jsx";
import {LoginModal} from "../../../establishment/accounts/js/LoginModal.jsx";
import {Ajax} from "../../../stemjs/src/base/Ajax.js";

export class SendFeedbackPanel extends CardPanel {
    haveSentFeedback = false;

    getTitle() {
        return UI.T("Feedback");
    }

    render() {
        const buttonOptions = !this.haveSentFeedback ? {
            label: UI.T("Send feedback"),
            level: Level.PRIMARY,
            icon: "book",
            onClick: () => this.sendFeedback(),

        } : {
            label: UI.T("Thanks for your feedback!"),
            level: Level.SUCCESS,
            disabled: true,
            icon: "check-square",
        }

        return [<div style={{textAlign: "center", fontSize: "1.1em", height: "30px", lineHeight: "30px"}}>
            {UI.T("Tell us what you think!")}
        </div>,
            <div ref="writingSection" className="text-center">
                {!this.haveSentFeedback && <TextArea ref="textInput" style={{
                    overflow: "auto",
                    resize: "none",
                    width: "100%",
                    maxWidth: "90%",
                    height: "30px",
                    borderRadius: "0px",
                }}/>}
                <Button
                    style={{
                        margin: 2,
                        backgroundColor: "#fff",
                        border: "0",
                        color: "#337ab7",
                        padding: "0",
                        marginTop: 2
                    }}
                    {...buttonOptions}
                />

            </div>];
    }


    async sendFeedback() {
        if (!USER.isAuthenticated) {
            LoginModal.show();
            return;
        }
        let message = (this.textInput.getValue() || "").trim();
        if (message.length === 0 || this.options.sentFeedback) {
            // TODO have an alert message here
            return;
        }

        const request = {
            message: message,
            clientMessage: "{}"
        };

        await Ajax.postJSON("/send_feedback/", request);

        this.haveSentFeedback = true;
        this.redraw();
    }
}